/**
 * Gravity forms
 */

var inputs = document.querySelectorAll(
  ".gfield textarea, .gfield input, .gfield select"
);

inputs.forEach(function (input) {
  var placeholder = document.querySelector("label[for='" + input.id + "']");

  if (placeholder) {
    placeholder.classList.add("gfield_label_placeholder");
  }

  if (input.value) {
    if (placeholder) {
      placeholder.classList.add("gfield_label--focus");
    }
    input.classList.add("focused");
  }
});

inputs.forEach(function (input) {
  input.addEventListener("focus", function () {
    var label = document.querySelector("label[for='" + this.id + "']");

    label.classList.add("gfield_label--focus");
    this.classList.add("focused");
  });

  input.addEventListener("blur", function () {
    var label = document.querySelector("label[for='" + this.id + "']");

    if (!this.value) {
      label.classList.remove("gfield_label--focus");
      this.classList.remove("focused");
    }
  });
});

// check if the form is being submitted and check if the fields still have content and add focused class
document.addEventListener("gform/post_render", function () {
  inputs.forEach(function (input) {
    if (input.value) {
      var label = document.querySelector("label[for='" + input.id + "']");

      if (label) {
        label.classList.add("gfield_label--focus");
      }

      input.classList.add("focused");
    }
  });
});
